<template>
    <router-view></router-view>
</template>

<script>
export default {
    created(){
         this.$store.dispatch("Layouts/set_layout", 'admin-layout');
    }
}
</script>